import { useState } from 'react';
import { useRouter } from '@tanstack/react-router';
import { Button, H1, Paragraph, Spinner, YStack } from 'tamagui';
import { Screen } from '@mrrmlab/ui';
import { useAppAuth } from '../app-context';

export interface LoginSearch {
  returnTo?: string;
}

export function LoginRoute({ returnTo }: { returnTo?: string }) {
  const auth = useAppAuth();
  const router = useRouter();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const signIn = async () => {
    if (!auth) {
      router.navigate({ to: returnTo ?? '/', replace: true });
      return;
    }
    setBusy(true);
    setError(null);
    try {
      const url = await auth.startLogin(returnTo ?? '/');
      window.location.assign(url);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
      setBusy(false);
    }
  };

  return (
    <Screen>
      <H1>mrrmlab</H1>
      <YStack gap="$3" marginTop="$4" maxWidth={320}>
        {busy ? <Spinner /> : null}
        {error ? <Paragraph color="$red10">{error}</Paragraph> : null}
        <Button onPress={signIn} disabled={busy}>
          Anmelden
        </Button>
        {!auth ? (
          <Paragraph color="$color10" textAlign="center">
            Dev-Modus: Kein Keycloak konfiguriert.
          </Paragraph>
        ) : null}
      </YStack>
    </Screen>
  );
}
